import { Input } from '@fluentui/react-components';
import { LocationArrowRightFilled } from '@fluentui/react-icons';
import { useState } from 'react';
import { parseLatLng } from '@moko/utils';
import { useOtherInfoContext } from '../OtherInfoContext';
import { isFieldReadOnly } from '../fieldReadOnly';
import MapPickDialog, { LocationHelper } from '../MapPickDialog';
import { FieldWrapper } from './FieldWrapper';
import type { FieldComponentProps } from './types';

export const CoordinateField = ({
  field,
  fieldValue,
  isFieldDisabled,
  isSaved,
  validationMessage,
}: FieldComponentProps) => {
  const { handleOtherInfoChange } = useOtherInfoContext();
  const [isMapPickOpen, setIsMapPickOpen] = useState(false);
  const location = parseLatLng(fieldValue) ?? undefined;

  return (
    <>
      <FieldWrapper field={field} validationMessage={validationMessage}>
        <div
          style={{
            position: 'relative',
            width: '100%',
            marginLeft: 0,
            height: 32,
          }}
        >
          <Input
            id={field.name}
            style={{ width: '100%' }}
            contentAfter={
              <LocationArrowRightFilled
                style={{ cursor: isFieldDisabled ? 'default' : 'pointer' }}
                onClick={() => {
                  if (isFieldDisabled) return;
                  setIsMapPickOpen(true);
                }}
              />
            }
            type="text"
            value={location ? LocationHelper.locationToString(location) : ''}
            readOnly={isSaved || isFieldReadOnly(field)}
            disabled={isFieldDisabled}
          />
        </div>
      </FieldWrapper>
      {isMapPickOpen && (
        <MapPickDialog
          isModalOpen
          hideModal={() => setIsMapPickOpen(false)}
          location={location}
          onMapClick={(newLocation) => {
            handleOtherInfoChange(field.name, {
              latitude: newLocation.latitude,
              longitude: newLocation.longitude,
            });
            setIsMapPickOpen(false);
          }}
        />
      )}
    </>
  );
};
